module.exports = __webpack_public_path__ + "img/parintins-boi-caprichoso.7596711a.jpg";